import { CompetitionGroup } from '@plvs/graphql'
import {
  SchoolComponentProps,
  SchoolComponentReturn,
} from '../types/schoolRenderController.types'

export const determineSchoolRender = ({
  competitionGroup,
}: SchoolComponentProps): SchoolComponentReturn => {
  if (competitionGroup === CompetitionGroup.ElementarySchool) {
    return {
      shouldRenderPlayers: false,
      shouldRenderAwards: false,
      shouldRenderUpdates: false,
    }
  }

  return {
    shouldRenderPlayers: true,
    shouldRenderAwards: true,
    shouldRenderUpdates: true,
  }
}
